export const LAYOUT_NAV_ID = 'layout-service-nav-v2';

/**
 * True when the DOM has two or more `z-unified-nav-v2` elements **and** this
 * instance’s `id` is the layout-service id (`LAYOUT_NAV_ID`). In that overlap
 * (layout service + upstream both injecting the nav), the layout-service
 * instance should suppress duplicate chrome—same concern as the
 * `suppressNestedDuplicateChrome` prop on `Navigation`.
 *
 * @deprecated Interim guard for the incomplete layout-service → upstream
 * migration. Do not build new behavior on top of it; it will be removed when
 * nested duplicate mounts no longer occur.
 */
export function isLayoutServiceNavNestedDuplicate(
  elementId?: string | null,
): boolean {
  const hasMultipleNavs =
    Array.from(document.getElementsByTagName('z-unified-nav-v2')).length >= 2;

  return hasMultipleNavs && elementId === LAYOUT_NAV_ID;
}
